import { useMapStore } from "../../store/useMapStore.js";
import { wgs84ToWebMercator } from "../../services/CoordinateTransformService.js";
import { BBOxRelativeToCenter, mercatorRelative } from "../../services/MercatorRelativeToCenter.js";


export class BPlanEntity {
    
    constructor(data = {}) {
        this.objectId = data.objectId || '';
        this.id = data.id || '';
        this.kommune = data.municipalityName || "";
        this.nutzungsart = data.landuse || '';
        this.type = data.type || '';
        this.url = data.url || '';
        this.label = data.label || '';
        this.Wirksamkeit = data.status || "";
        this.Name = "BPlanEntity";
        this.datum = "" ;// not in the database
        this.status = "" ;// not in the database
        //this.geometry = FlurstuckEntity.wgs84ToWebMercator(data.geometry) || null;
        this.geometry = data.geometry|| null;
        this.mercatorCoordinates= this.geometry.coordinates;
        this.center = useMapStore.getState().center;
     

    }

    // Static method to create multiple entities from raw response
    static fromResponse(response) 
    {
        
        // Check if the response structure matches your expected format
        if (response)
        {
           
            return response.data.developmentPlanByBounds.developmentPlans.map(
                entityData => new BPlanEntity(entityData)
            );
        }
        return [];
    }
}